import { useQuery } from '@tanstack/react-query';
import type { RankSummary } from '@seo/types';
import { apiGet } from '@/lib/api';

export function useRankSummary(projectId: string | undefined) {
  return useQuery({
    queryKey: ['rank-summary', projectId],
    queryFn: () => apiGet<RankSummary>(`/v1/rank-summary?project_id=${projectId}`),
    enabled: !!projectId,
    placeholderData: (prev) => prev,
  });
}
